import React from 'react'

export default function Home() {
  return (
    <div className='flex justify-center items-center text-richblack-100 text-3xl h-full'>
      Home
    </div>
  )
}
